import "core-js/modules/es.array.push.js";
import { onMounted, reactive, toRefs } from "vue";
import { Cell, List } from 'vant';
import AppHeader from '@/components-H5/AppHeader.vue';
import apis from "@/api";
import { useRouter } from 'vue-router';
import store from '@/store';
import 'vant/es/list/style';
import 'vant/es/cell/style';
export default {
  components: {
    AppHeader,
    List,
    Cell
  },
  setup(props, ctx) {
    let data = reactive({
      positions: null
    });
    onMounted(() => {
      getPosition();
    });
    const getPosition = () => {
      apis.getPosition().then(res => {
        if (res.success) {
          data.positions = res.data;
        }
      });
    };
    const router = useRouter();
    const selectPosition = pos => {
      store.commit("setCruiseShop", {
        posId: pos.id,
        posName: pos.nodeName
      });
      router.push(`/h5/cruiseShop/cruiseShopSubmit`);
    };
    return {
      ...toRefs(data),
      getPosition,
      selectPosition
    };
  }
};